import { render, staticRenderFns } from "./evaluacion-individual.vue?vue&type=template&id=6808fbd0&scoped=true&"
import script from "./evaluacion-individual.componet.ts?vue&type=script&lang=ts&"
export * from "./evaluacion-individual.componet.ts?vue&type=script&lang=ts&"
import style0 from "./evaluacion-individual.vue?vue&type=style&index=0&id=6808fbd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808fbd0",
  null
  
)

export default component.exports